import React, { useState } from 'react';
import { useSetting } from '../../../util/useSetting';
import PreviousSvg from '../../../svg/student/Previous.js';
import NextSvg from '../../../svg/student/Next.js';
import ReloadSvg from '../../../svg/student/Reload.js';
import { connect } from 'react-redux';
import SliderPage from './SliderPage';

const DATA = {
    name: '香港學生睡眠',
    tabs: [
        {
            name: '報章評論',
            url: 'https://www.news.com/article1',
            contents: [
                {
                    type: 'image',
                    src: '/secondary/tasks/rp4.png',
                },
                {
                    type: 'html',
                    html: '<br/><br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;每天早上，總有一些學生拖著書包、沒精打采地走進校門，甚至上完第一節課後仍然十分困倦。這幅常見景象，令「是否該把早會或第一節課延後」再次成為教育界爭議。這個建議並非毫無道理，但延後二十分鐘能否解決睡眠不足，卻不宜過早下定論。<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;香港已有學校開始嘗試調整時間。以明智中學為例，學校留意到部分學生在早上首兩節課精神不集中，因此計劃在下學期試行新的時間安排，把早會由上午8時延至8時20分，並相應調整第一節課、午膳和放學時間。<br/><br/>'
                },
                {
                    type: 'title',
                    text: '試行安排時間表'
                },
                {
                    type: 'html',
                    html: `
                    <table class='w-full' style='border: 1px solid #9CB8D3;'>
  <tr>
    <th class='text-center' style='background-color: #EDF5F8; border: 1px solid #9CB8D3;'>項目</th>
    <th class='text-center' style='background-color: #EDF5F8; border: 1px solid #9CB8D3;'>現行時間</th>
    <th class='text-center' style='background-color: #EDF5F8; border: 1px solid #9CB8D3;'>試行時間</th>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>校門開放</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午7:45</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午7:45</td>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>早會</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午8:00</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午8:20</td>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>第一節課</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午8:40</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午9:00</td>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>午膳</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>下午12:40</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>下午1:10</td>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>放學</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>下午4:00</td>
    <td class='text-center'style='border: 1px solid #9CB8D3;'>下午4:20</td>
  </tr>
</table>                    `
                },
                {
                    type: 'html',
                    html: '<br/><br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;此外，明智中學還計劃在試行期間收集教師的課堂觀察紀錄和學生問卷，並舉辦介紹睡眠與學業表現的家長講座。這些措施是良好的嘗試，但是否真的有幫助，仍要根據試行後學生的課堂專注度以及整體狀態來判斷。如果效果不明顯，學校也應重新檢視時間安排是否切合學生的實際需要。不同學校的校情、學生居住地點、交通和午膳安排不盡相同，也不宜立刻要求所有學校實行。<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;更重要的是，社會和學校不應把延後早間課堂看成解決學生睡眠問題的簡單答案。真正值得關注的，不是早會究竟延後多少分鐘，而是學生能否實現更充足和規律的作息，並在課堂保持較好的精神狀態。<br/><br/><br/><br/><br/>'
                }
            ]
        },

        {
            name: '新聞',
            url: 'https://www.news.com/article2',

            contents: [
                {
                    type: 'html',
                    html: `<br/>`
                },
                {
                    type: 'image',
                    src: '/secondary/tasks/rp5.png',
                },
                {
                    type: 'html',
                    html: `
                    <div class='w-full flex flex-col' style='margin-top: 16px; padding-left: 3%; padding-right: 3%; gap: 16px;'>
                        <div class='w-full font-bold text-white flex flex-row items-center' style='background-color: #3F96FD; padding: 16px; gap:16px;'>
                            <div style='width:12px; height:39px; background-color: #FF7961;'></div>
                            新聞 | 睡眠與健康
                        </div>
                        <div style='width: 100%; padding-left:10%; padding-right:10%; display: flex; flex-direction: column; align-items: start;'>
                            <b>小三睡9.5小時 中三睡8.5小時 成績最佳</b>
                            <br/>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本港青少年睡眠不足的情況越來越嚴重。香港中文大學精神科學系教授陳秀雯指出，受成績至上觀念影響，不少家長輕視睡眠健康，令學童不得不犧牲休息時間來溫書。她引用美國國家睡眠基金會的睡眠時長建議（見圖1），但達標港生只佔少數。她指出，學生「想睡也睡不到」，除了自身壓力，也與課堂安排、功課數量等學校因素有關。</p>
                            <br/>
                            <br/>
                            <div class='w-full flex justify-center items-center flex flex-col' style='margin-top: 16px;'>
                                <b>圖1：各年齡層建議睡眠時長</b>
                                <img src='/secondary/tasks/rp6.png' alt='圖1' style='max-width: 100%; height: auto;'/>
                            </div>
                            <div class='w-full flex justify-center items-end flex flex-col' style='margin-top: 6px; font-weight: 300;'>
                                資料來源：美國國家睡眠基金會（National Sleep Foundation），2015年
                            </div>
                            <br/>
                             <br/>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;除了學校課業，社會的補習文化亦十分普遍。陳秀雯認為，家長為子女安排興趣班、補習班之餘，亦應制定健康的睡眠時間表，「今天的事做不完，可否明天再算呢？分數重要之餘，會否孩子的精神健康更加重要呢？」她還提到團隊前年一項研究，指出港生睡眠時間與學業成績呈明顯「倒U形」關係。也就是說，學生的睡眠時間過短或太長，學業成績都可能較差。其中，小三生每天睡眠9.5小時、中三生每天睡眠8.5小時的成績最好。她重申，增加一些睡眠時間並不會妨礙學童取得好成績，並呼籲家長重視兒童的睡眠習慣。</p>
                            <br/>
                             <b>亞洲人睡較少 港遲睡遲起 假日補眠或擾亂作息</b>
                             <br/>
                            
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;除了睡眠不足，許多港人亦有晚睡、假日補眠等睡眠問題。香港中文大學精神科學系系主任榮潤國教授指出，海外研究曾比較不同國家及地區人士的睡眠習慣。結果顯示，亞洲人睡眠時間較短，而香港人在工作日的睡覺時間最遲，青少年也有相似情況。都市人普遍利用週末或假期補眠，但也無法彌補平日睡眠不足，反而更加擾亂作息，導致睡眠節奏紊亂及社交時差（social jetlag），即假日作息就像生活在另一時區，並可能增加情緒及行為問題。</p>
                            
                            <br/>
                            <br/>
                        </div>
                    </div>

                    `
                }
            ]
        }
    ],
    questions: [
        {
            type: 'display-text',
            html: '最近，你和同學子晴上早課時總是提不起精神，還不時打呵欠。一天小息時，你們在社交平台看到一篇討論學校應否延後早會或第一節課的報章評論，便好奇地點進去閱讀。<br/><br/>點擊「下一頁」的箭號來閱讀第一個來源。'
        },
        {
            id: '1',
            type: '選擇題',
            question: '1. 根據報章評論中的描述，以下哪項最能概括明智中學校方的處理方式？',
            subtitle: '參考左側的「報章評論」，點擊一個選項來回答本題。',
            options: [
                { text: 'A. 縮短在校時間，觀察學生睡眠變化' },
                { text: 'B. 調整上課時間，配合講座及成效檢視' },
                { text: 'C. 舉辦家長講座，再決定是否調整時間' },
                { text: 'D. 依靠教師觀察，暫不收集學生意見' }
            ],
            tab: 0,
        },
        {
            id: '2',
            type: '表格問題',
            question: '2. 根據報章評論內容及「明智中學試行安排時間表」，判斷以下說法是否正確。',
            subtitle: '參考左側的「報章評論」，點擊一個選項來回答本題。',
            header: ['陳述', '正確', '錯誤'],
            table: [
                { text: '（1）報章評論提到部分學生早上精神不集中，沒有交代涉及人數或比例，暫難判斷問題是否普遍。' },
                { text: '（2）根據明智中學試行時間表，試行前後早會與第一節課之間的時間間隔相同。' },
                { text: '（3）由於已有試行新的時間安排，可將其做法直接推廣至所有學校。' },
                { text: '（4）若明智中學試行新時間表後學生早上的課堂表現有所改善，便足以證明這是延後早會的效果。' }
            ],
        },
        {
            type: 'display-text',
            html: '看到報章評論提到學生的睡眠情況和學生的精神狀態相關，子晴好奇地說：「那麼睡眠會不會影響上課表現呢？」你們在網上搜尋相關資料，找到一篇介紹香港學童睡眠問題的健康新聞。<br/><br/>點擊「下一頁」的箭號來閱讀第二個來源。'
        },
        {   
            id:'3',
            type: '填寫問題',
            subtitle: '請根據第二個來源的內容回答以下問題。',
            question_prefix: '3. 根據圖1，14至17歲（中學）學生每天建議至少睡',
            question_postfix: '小時。'
        },
         {
            id: '4',
            type: '選擇題',
            question: '4. 新聞最後一段提到，週末或假期補眠可能導致「社交時差」，這裡所說的「社交時差」是指甚麼？',
            subtitle: '請填寫答案',
            options: [
                { text: 'A. 外出旅行跨越時區，身體未能適應當地時間' },
                { text: 'B. 深夜使用社交媒體，使每天的入睡時間延後' },
                { text: 'C. 平日與假日作息不同，如同身處於另一時區' },
                { text: 'D. 社交活動時間過長，導致每天睡眠時長不足' }
            ],
            tab: 0,
        },
        {
            id: '5',
            type: '選擇題',
            question: '5. 子晴準備在2026年的家長講座中把圖1介紹為「目前最新的睡眠時數建議」。根據圖1，以下哪項處理最恰當？',
            subtitle: '請填寫答案',
            options: [
                { text: 'A. 先查核該機構其後有否更新相關睡眠建議。' },
                { text: 'B. 直接保留這個說法，因為資料來自專業機構。' },
                { text: 'C. 介紹改為介紹香港學生目前實際的睡眠時間。' },
                { text: 'D. 介紹改為比較圖中不同年齡層的建議睡眠時數。' }
            ],
            tab: 0,
        },
        {
            id: '6',
            type: '選擇題',
            question: '6. 新聞第二段引用陳秀雯教授所說，「分數重要之餘，會否孩子的精神健康更加重要呢？」文章引用這個反問句，主要作用是甚麼？',
            subtitle: '請填寫答案',
            options: [
                { text: 'A. 總結前文有關成績對學生身心的影響' },
                { text: 'B. 顯示陳教授其實並未決定支持哪一方' },
                { text: 'C. 避免直接評論家長們的不同教育觀念' },
                { text: 'D. 引導讀者反思分數與精神健康的取捨' }
            ],
            tab: 0,
        },
        {
            id: '7',
            type: '選擇題',
            question: '7. 一個為14至17歲學生舉辦的兩星期住宿音樂營，發現部分營員在早上排練時精神不集中。負責人準備試行新的作息安排。綜合資料，以下哪項方案最恰當？',
            subtitle: '請填寫答案',
            options: [
                { text: 'A. 每天睡7小時，平日與週末作息一致，觀察早上排練的專注情況。' },
                { text: 'B. 每天睡8小時，平日與週末作息一致，觀察早上排練的專注情況。' },
                { text: 'C. 每天睡8小時，週末晚睡晚起3小時，觀察早上排練的專注情況。' },
                { text: 'D. 每天睡8小時，平日與週末作息一致，記錄早上排練的出席情況。' }
            ],
            tab: 0,
        },
        {
            id: '8',
            type: '選擇題',
            question: '8. 子晴整理以上兩則資料時，想找出其中一項在兩邊都有直接提及的內容。以下哪項符合？',
            subtitle: '請填寫答案',
            options: [
                { text: 'A. 睡眠時間和作息規律' },
                { text: 'B. 教師觀察學生課堂狀態' },
                { text: 'C. 假日補眠與社交時差' },
                { text: 'D. 功課量與學生睡眠時間' }
            ],
            tab: 0,
        },
        {   
            id: '9',
            type: '拖放式問題'
        },
        {
            id: '10',
            type: '短句作答題', 
            question: '10. 健康新聞指出，睡眠時間過長時，學業成績也可能較差；陳秀雯教授則表示，增加一些睡眠時間，並不會妨礙學童取得好成績。這兩項說法是否矛盾？請結合文章中香港學生的睡眠情況及研究結果解釋。',
            subtitle: '請填寫答案',
        },
    ]
}

function Task(props) {
    const { fontSize } = useSetting();
    const [data, setData] = useState(DATA)
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const handlePrevious = () => {
        let prevIndex = currentQuestionIndex - 1;
        if (prevIndex >= 0) {
            setCurrentQuestionIndex(prevIndex);
        }
    }
    const handleNext = () => {
        let nextIndex = currentQuestionIndex + 1;
        if (nextIndex < data.questions.length) {
            setCurrentQuestionIndex(nextIndex);
        }
    }
    const [tab, setTab] = useState(0);

    return (
        <div className='w-full flex flex-col h-full' style={{ fontSize }}>

            <div className='w-full flex flex-row justify-start gap-[8px] mt-[16px] px-[16px] font-[900]'>
                <button className='px-[18px] py-[4px] rounded-full flex flex-row items-center text-[white] gap-[8px] noto-san-hk font-[600]' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }}>
                    <img src='/secondary/setting.png' alt='設定' />
                    設定
                </button>
                <div className='flex flex-row gap-[8px] flex-1 justify-end'>
                    <button>
                        <img src='/secondary/btn1.png' />
                    </button>
                    <button onClick={handlePrevious}>
                        <img src='/secondary/btn2.png' />
                    </button>
                    <button onClick={handleNext}>
                        <img src='/secondary/btn3.png' />
                    </button>
                </div>


            </div>

            <div className='w-full flex flex-col items-center justify-center flex-1 overflow-auto noto-san-hk mt-[12px]'>

                {data?.questions[currentQuestionIndex]?.type === 'display-text' ? (
                    <div className='flex-1 flex flex-col w-full justify-center items-center'>
                        <div className='w-full text-white font-bold flex flex-col text-left px-[24px] py-[8px]' style={{ background: 'linear-gradient(to right, #55A8E0, #1C7595, #3B77A4)' }}>
                            {data?.name}<br />簡介
                        </div>
                        <div className='flex-1 w-full flex justify-center items-center'>
                            <div className='text-[#003A57] w-full max-w-[800px] text-left flex justify-center items-center' style={{ border: '1px solid #E3E3E3', padding: '64px' }}>
                                <div className='w-full max-w-[400px]' dangerouslySetInnerHTML={{ __html: data?.questions[currentQuestionIndex]?.html }} />
                            </div>
                        </div>
                    </div>
                ) : (
                    <SliderPage initalWidth={35}
                        leftComponent={<LeftComponent data={data} currentQuestionIndex={currentQuestionIndex} setData={setData} />}
                        rightComponent={<RightComponent data={data} currentQuestionIndex={currentQuestionIndex} setData={setData} tab={tab} setTab={setTab} />}
                    />
                )}
            </div>

        </div>
    )
}


function LeftComponent(props) {
    const data = props.data;
    const { fontSize } = useSetting();
    return <div className='flex flex-col w-full'>
        <div className='flex-1 flex flex-col w-full justify-center items-center'>
            <div className='w-full text-white font-bold flex flex-col text-left px-[24px] py-[8px]' style={{ background: 'linear-gradient(to right, #55A8E0, #1C7595, #3B77A4)' }}>
                {data?.name}<br />簡介
            </div>
        </div>
        {data?.questions[props.currentQuestionIndex]?.type === '選擇題' && (
            <div className='flex-1 w-full flex flex-col justify-start items-start p-[16px] gap-[16px]'>
                <div className='text-[#082037] font-[300]' style={{ fontSize: fontSize - 2 }}>{data?.questions[props.currentQuestionIndex]?.subtitle}</div>
                <div className='text-[#082037] font-[900]' style={{ fontSize: fontSize }}>{data?.questions[props.currentQuestionIndex]?.question}</div>
                <div className='w-full flex flex-col gap-[16px]'>
                    {data?.questions[props.currentQuestionIndex]?.options.map((option, oi) =>
                        <div key={oi} className='w-full text-[black] flex flex-row items-center gap-[16px] font-[400]'>
                            <button className='w-[20px] h-[20px] border border-[#005B8C] rounded-full flex-shrink-0' style={{ backgroundColor: option.selected ? '#005B8C' : 'transparent' }} onClick={
                                () => {
                                    let newData = { ...data }
                                    for (let op of data?.questions[props.currentQuestionIndex].options) {
                                        op.selected = false
                                    }
                                    newData.questions[props.currentQuestionIndex].options[oi].selected = true
                                    props.setData(newData)
                                }
                            }>

                            </button>
                            {option.text}
                        </div>
                    )}
                </div>
            </div>
        )}
        {['表格問題'].includes(data?.questions[props.currentQuestionIndex]?.type) && (
            <div className='w-full flex flex-col gap-[8px] rounded-[7px] mt-[24px] px-[24px]'>
                <div className='text-[#082037] font-[300]' style={{ fontSize: fontSize - 2 }}>{data?.questions[props.currentQuestionIndex]?.subtitle}</div>
                <div className='text-[#082037] font-[900]' style={{ fontSize: fontSize }}>{data?.questions[props.currentQuestionIndex]?.question}</div>
                <div className='flex flex-col w-full mt-[16px]'>
                    <div className='flex flex-row items-stretch w-full border-black font-[700]'>
                        <div className='bg-[#EDF5F8] text-black flex-1 border-[#9CB8D3] border-[1px] w-full px-[12px] py-[4px] flex items-center justify-center'>
                            {data.questions[props.currentQuestionIndex]?.header?.[0] || ''}
                        </div>
                        <div className='bg-[#EDF5F8] text-black border-[#9CB8D3] border-[1px] px-[12px] py-[4px] text-center flex items-center justify-center' style={{ width: 100 }}>
                            {data.questions[props.currentQuestionIndex]?.header?.[1] || ''}
                        </div>
                        <div className='bg-[#EDF5F8] text-black border-[#9CB8D3] border-[1px] px-[12px] py-[4px]  text-center flex items-center justify-center' style={{ width: 100 }}>
                            {data.questions[props.currentQuestionIndex]?.header?.[2] || ''}
                        </div>
                    </div>
                    {data?.questions[props.currentQuestionIndex]?.table?.map((row, rowIndex) => (
                        <div key={rowIndex} className='flex flex-row items-stretch'>
                            <div className='flex-1 border-[#9CB8D3] border-x-[1px] border-y-[1px] px-[12px] py-[4px]'>{row.text}</div>
                            <div className='border-[#9CB8D3] border-[1px] px-[12px] py-[4px] flex flex-row justify-center items-center' style={{ width: 100 }}>
                                <div>
                                    <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                        <button
                                            className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${row.answer1 ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                            onClick={() => {
                                                let data_ = { ...data }
                                                if (data_.questions[props.currentQuestionIndex]?.data?.multipleChoiceType !== '多項選擇題') {
                                                    data_.questions[props.currentQuestionIndex].table[rowIndex].answer1 = true
                                                    data_.questions[props.currentQuestionIndex].table[rowIndex].answer2 = false
                                                } else
                                                    data_.questions[props.currentQuestionIndex].table[rowIndex].answer1 = !data_.questions[props.currentQuestionIndex].table[rowIndex].answer1
                                                props.setData(data_)
                                            }}
                                        ></button>
                                    </div>
                                </div>
                            </div>
                            <div className=' border-[#9CB8D3] border-[1px] px-[12px] py-[4px] flex flex-row justify-center justify-center items-center' style={{ width: 100 }}>
                                <div>
                                    <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                        <button
                                            className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${row.answer2 ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                            onClick={() => {
                                                let data_ = { ...data }
                                                if (data_.questions[props.currentQuestionIndex]?.data?.multipleChoiceType !== '多項選擇題') {
                                                    data_.questions[props.currentQuestionIndex].table[rowIndex].answer2 = true
                                                    data_.questions[props.currentQuestionIndex].table[rowIndex].answer1 = false
                                                } else
                                                    data_.questions[props.currentQuestionIndex].table[rowIndex].answer2 = !data_.questions[props.currentQuestionIndex].table[rowIndex].answer2
                                                props.setData(data_)
                                            }}
                                        ></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
        )}
        {/*end of form table question*/}

        {['填寫問題'].includes(data?.questions[props.currentQuestionIndex]?.type) && (
            <div className='w-full flex flex-col gap-[8px] rounded-[7px] mt-[24px] px-[24px]'>
                <div className='text-[#082037] font-[300]' style={{ fontSize: fontSize - 2 }}>{data?.questions[props.currentQuestionIndex]?.subtitle}</div>
                <div className='flex flex-row items-center flex-wrap justify-start gap-[8px]'>
                    <div className='text-[#082037] font-[900]' style={{ fontSize: fontSize }}>{data?.questions[props.currentQuestionIndex]?.question_prefix}</div>
                    <input className='w-[100px] border-b border-black bg-[transparent]' />
                    <div className='text-[#082037] font-[900]' style={{ fontSize: fontSize - 2 }}>{data?.questions[props.currentQuestionIndex]?.question_postfix}</div>
                </div>
            </div>)}

        {['短句作答題'].includes(data?.questions[props.currentQuestionIndex]?.type) && (
            <div className='w-full flex flex-col gap-[8px] rounded-[7px] mt-[24px] px-[24px]'>
                <div className='text-[#082037] font-[300]' style={{ fontSize: fontSize - 2 }}>{data?.questions[props.currentQuestionIndex]?.subtitle}</div>
                <div className='flex flex-row items-center flex-wrap justify-start gap-[8px]'>
                    <div className='text-[#082037] font-[900]' style={{ fontSize: fontSize }}>{data?.questions[props.currentQuestionIndex]?.question}</div>
                    <textarea className='w-full border-[1px] rounded-[4px] border-black bg-[white] min-h-[100px] mt-[16px] p-[4px]' />
                </div>
            </div>
        )}

    </div>;
}
function RightComponent(props) {
    const { fontSize } = useSetting();
    return <div className='flex flex-col w-full'>

        <div className='w-full flex flex-row justify-start gap-[8px] px-[16px] font-[900]'>
            {props.data?.tabs?.map((tab, ti) => (
                <button
                    key={ti}
                    className='flex-1 max-w-[220px] overflow-hidden text-ellipsis whitespace-nowrap text-center py-[4px]'
                    style={props.tab === ti ? { background: 'linear-gradient(to left, #108B96, #003A57)', color: 'white', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' } : { background: 'linear-gradient(to bottom, #ccc, #fff)', color: '#003A57', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                    onClick={() => { props.setTab(ti) }}
                >
                    {tab.name}
                </button>
            ))}
        </div>
        <div className='w-full flex flex-row bg-[white] items-center' style={{ borderBottom: '1px solid #E3E3E3', marginTop: 4, gap: 6, padding: 6 }}>
            <div className='cursor-pointer'>
                <PreviousSvg height={30} width={30} />
            </div>
            <div className='cursor-pointer'>
                <NextSvg height={30} width={30} />
            </div>
            <div className='cursor-pointer'>
                <ReloadSvg height={30} width={30} />
            </div>
            <div className='flex-1'>
                <input disabled={true} className='w-full text-[black] bg-[#EEF2F6] rounded-[4px]' value={props.data?.tabs?.[props.tab]?.url ?? 'https://task.com'} style={{ fontSize: fontSize - 4, height: 40, paddingLeft: 24, paddingRight: 24 }} />
            </div>
        </div>
        <div className='w-full flex flex-col overflow-auto flex-1 gap-[16px] bg-white'>
            {props.tab !== undefined && props.data?.tabs?.[props.tab]?.contents?.map((content, ci) => (
                <div key={ci}>
                    {content.type === 'image'
                        ? <img src={content.src} alt='' />
                        : content.type === 'html'
                            ? <div className='px-[16px]' dangerouslySetInnerHTML={{ __html: content.html }} />
                            : content.type === 'title'
                                ? <div className='w-full px-[16px] text-center' style={{ fontSize: fontSize + 2, fontWeight: 'bold' }}>{content.text}</div>
                                : null
                    }
                </div>
            ))}

        </div>
    </div>;
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Task)
